// /src/pages/LandingPage.js
import React from 'react';
import { Link } from 'react-router-dom';
import Header from '../components/Header';
import './LandingPage.css'

const LandingPage = () => {
  return (
    <div className="landing-page">
      {/* Hero Section */}
      <div className="landing-content">
        <h1 className="landing-title">RocketPrepAI</h1>
        <p className="landing-tagline">Capable AI powered SAT prep</p>
        <p className="landing-description">
          RocketPrepAI is designed to offer users a better, cheaper, and more capable AI test-preparation solution than what existing services offer. Unlock your SAT potential with advanced user analytics and real-life level questions.
        </p>
        <p className="pricing-card">
          RocketPrepAI is <span className="price-highlight">Free</span>!<br></br> Or, try our personalized reviews with our standard plan
  for only <span className="price-highlight">$4.99 a month</span>

</p>        <Link to="/signup" className="start-now-button">
          Sign up now!
        </Link>
  
      </div>

      {/* How It Works Section */}
      <section className="how-it-works-section">
        <div className="section-content">
          <h2 className="section-title">How does RocketPrepAI Work?</h2>
          <p className="section-description">
            RocketPrepAI uses Large Language Models (like ChatGPT) to generate SAT practice questions to help you improve your score, using a revolutionary approach utilizing question review and grading.
          </p>
          <p className="section-description">
            We are different than our competitors in that we prioritize question quality and the use of AI to provide detailed reviews on user performance in different areas and what they need to improve on.
          </p>
        </div>
      </section>

      {/* Features Section */}
      <section className="features-section">
        <div className="section-content">
          <h2 className="section-title">Features</h2>
          <div className="features-grid">
            <div className="feature-card">
              <div className="feature-icon">🎯</div>
              <h3 className="feature-title">Adaptive Practice Sessions</h3>
              <p className="feature-description">
                RocketPrepAI adapts to your performance to offer personalized questions.
              </p>
            </div>
            <div className="feature-card">
              <div className="feature-icon">📊</div>
              <h3 className="feature-title">Detailed AI Reviews</h3>
              <p className="feature-description">
                AI session reviews that tell you not just what you got wrong, but why - and how you can improve.
              </p>
            </div>
            <div className="feature-card">
              <div className="feature-icon">🚀</div>
              <h3 className="feature-title">More Coming Soon!</h3>
              <p className="feature-description">
                We're constantly developing new features to enhance your SAT preparation experience.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Who We Are Section */}
      <section className="team-section">
        <div className="section-content">
          <h2 className="section-title">Who are we?</h2>
          <p className="team-intro">
            RocketPrepAI was created by members of the West Seattle High School Rocketry Club. As high schoolers who understand what it's like to prepare for the SAT, we decided to create our own study solution.
          </p>
          
          {/* Team Photo */}
          <div className="team-photo-container">
            <img 
              src="images/team_photo.jpg" 
              alt="RocketPrepAI Team - West Seattle High School Rocketry Club members" 
              className="team-photo"
            />
            <p className="team-photo-caption">The RocketPrepAI team. Left to right: Leo McClintock, Nathan Vuong, Arthur Johnston, and Aidan Busby</p>
          </div>
          
          <div className="team-grid">
            <div className="team-member">
              <h3 className="member-name">Aidan Busby</h3>
              <p className="member-role">Founder and Chief Engineer</p>
            </div>
            <div className="team-member">
              <h3 className="member-name">Leo McClintock</h3>
              <p className="member-role">Head of Marketing</p>
            </div>
            <div className="team-member">
              <h3 className="member-name">Nathan Vuong</h3>
              <p className="member-role">Head of Finance</p>
            </div>
            <div className="team-member">
              <h3 className="member-name">Arthur Johnston</h3>
              <p className="member-role">Swiss Army Knife</p>
            </div>
          </div>
        </div>
      </section>

      {/* Call to Action */}
      <section className="cta-section">
        <div className="section-content">
          <h2 className="cta-title">Ready to boost your SAT score?</h2>
          <Link to="/signup" className="cta-button">
            Get Started Today
          </Link>
        </div>
      </section>
    </div>
  );
};

export default LandingPage;
